import type { InboundReceiptDetailDto } from '../../inbound-receipts/inbound-receipts-shared.dto.js';

export const inboundReceiptSyncEntityTypeValues = ['inboundReceipt'] as const;
export type InboundReceiptSyncEntityType = (typeof inboundReceiptSyncEntityTypeValues)[number];

export const inboundReceiptSyncEventTypeValues = [
  'inboundReceiptConfirmedV2',
  'inboundReceiptOfficialStateReplacedV2',
  'inboundReceiptComparisonReviewedV2',
  'inboundReceiptInventoryPostedV2',
  'inboundReceiptInventoryPostingReversedV2',
  'inboundReceiptCanceledV2',
] as const;
export type InboundReceiptSyncEventType = (typeof inboundReceiptSyncEventTypeValues)[number];

export interface InboundReceiptSyncPayloadBase {
  schemaVersion: 2;
  eventId: string;
  occurredAt: string;
  companyId: string;
  stationId: string;
  receiptId: string;
}

export interface InboundReceiptConfirmedEventPayload extends InboundReceiptSyncPayloadBase {
  receipt: InboundReceiptDetailDto;
}

export interface InboundReceiptCanceledEventPayload extends InboundReceiptSyncPayloadBase {
  canceledAt: string;
  canceledByUserId: string;
}

export interface InboundReceiptOfficialStateReplacedEventPayload
  extends InboundReceiptSyncPayloadBase {
  officialSettlement: InboundReceiptDetailDto['officialSettlement'];
  officialComparison: InboundReceiptDetailDto['officialComparison'];
}

export interface InboundReceiptComparisonReviewedEventPayload
  extends InboundReceiptSyncPayloadBase {
  officialComparison: InboundReceiptDetailDto['officialComparison'];
}

export interface InboundReceiptInventoryPostedEventPayload extends InboundReceiptSyncPayloadBase {
  receipt: InboundReceiptDetailDto;
}

export interface InboundReceiptInventoryPostingReversedEventPayload
  extends InboundReceiptSyncPayloadBase {
  receipt: InboundReceiptDetailDto;
  reason?: string | null;
}
